// extracted by mini-css-extract-plugin
module.exports = {"sectionWrapper":"_3WXFh","contentList":"_24dCz","subTitle":"_1B0Hn"};